<div [ngSwitch]="type"
     class="layout-row field-container">
    <ng-container *ngSwitchCase="ValueType.Text">
        <mat-form-field [class.mat-form-field-invalid-color]="form?.invalid &&
                                                            form?.dirty">
            <input [(ngModel)]="value"
                   [disabled]="disabled"
                   [placeholder]="valuePlaceholder"
                   (input)="registerChange(value)"
                   (blur)="registerTouch($event)"
                   matInput
                   required />
            <mat-hint class="errorMessage">
                <ng-container *ngTemplateOutlet="hintPrimary"></ng-container>
            </mat-hint>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="ValueType.Integer">
        <mat-form-field [class.mat-form-field-invalid-color]="form?.invalid &&
                                                            form?.dirty">
            <input [(ngModel)]="value"
                   [disabled]="disabled"
                   [placeholder]="valuePlaceholder"
                   (input)="registerChange(value)"
                   (blur)="registerTouch($event)"
                   matInput
                   uiRestrictInput="^[-0-9]+$"
                   pattern="^-?[0-9]+"
                   required />
            <mat-hint class="errorMessage">
                <ng-container *ngTemplateOutlet="hintPrimary"></ng-container>
            </mat-hint>
        </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="ValueType.Credential">
        <ng-container *ngIf="readonlyCredential; else writeBlock">
            <mat-form-field [class.mat-form-field-invalid-color]="form?.invalid &&
                                                                form?.dirty">
                <mat-label>{{ externalNamePlaceholder }}</mat-label>
                <input [(ngModel)]="value"
                       [disabled]="disabled"
                       [placeholder]="externalNamePlaceholderName"
                       [required]="isRobot"
                       (input)="registerChange(value)"
                       (blur)="registerTouch($event)"
                       matInput />
                <mat-hint class="errorMessage">
                    <ng-container *ngTemplateOutlet="hintPrimary"></ng-container>
                </mat-hint>
            </mat-form-field>
        </ng-container>
        <ng-template #writeBlock>
            <mat-form-field [class.mat-form-field-invalid-color]="form?.dirty &&
                                                                (
                                                                    ngControl.hasError('username.maxlength') ||
                                                                    ngControl.hasError('required')
                                                                )"
                            class="flex-45 field-username">
                <input [(ngModel)]="asCredential(value).username"
                       [disabled]="disabled"
                       [placeholder]="usernamePlaceholder"
                       (input)="registerChange(value)"
                       (blur)="registerTouch($event)"
                       matInput
                       uiPreventAutofill
                       required />
                <mat-hint class="errorMessage">
                    <ng-container *ngTemplateOutlet="hintPrimary"></ng-container>
                </mat-hint>
            </mat-form-field>
            <span class="flex"></span>
            <mat-form-field [class.mat-form-field-invalid-color]="form?.dirty &&
                                                                (
                                                                    ngControl.hasError('password.maxlength') ||
                                                                    ngControl.hasError('required')
                                                                )"
                            class="flex-45">
                <input #passwordInput
                       [(ngModel)]="asCredential(value).password"
                       [disabled]="disabled"
                       [placeholder]="passwordPlaceholder"
                       (input)="registerChange(value)"
                       (blur)="registerTouch($event)"
                       matInput
                       uiPreventAutofill
                       type="password"
                       required />
                <span matSuffix>
                    <ui-password-toggle [element]="passwordInput"
                                        [tooltipShow]="tooltipShow"
                                        [tooltipHide]="tooltipHide"></ui-password-toggle>
                </span>
                <mat-hint class="errorMessage">
                    <ng-content select="[hint-secondary]">
                    </ng-content>
                </mat-hint>
            </mat-form-field>
        </ng-template>
    </ng-container>
    <ng-container *ngSwitchCase="ValueType.Bool">
        <mat-form-field>
            <ui-toggle-switch [(ngModel)]="value"
                              [disabled]="disabled"
                              [onString]="truePlaceholder"
                              [offString]="falsePlaceholder"
                              [placeholder]="valuePlaceholder"
                              (optionChange)="registerChange(value)"
                              (blur)="registerTouch($event)">
            </ui-toggle-switch>
        </mat-form-field>
    </ng-container>
    <ng-template #hintPrimary>
        <ng-content select="[hint-primary]">
        </ng-content>
    </ng-template>
</div>
